import { SuggestedRouteEvents } from "../../local_modules/voyage-suggested-routes/src/types";
import { FloatPanelComponent } from "../../vessel/src/main-app";
import { UiStateModel, UiStateModelParam } from "../models/ui-state-model";
import { VesselPlanningModel, VoyagePlan } from "../models/vessel-planning-model";
import { NavtexStation, VesselRs1345Model } from "../models/vessel-rs1345-model";
import { VoyageRoutingModel } from "../models/voyage-routing-model";
import { CrossedGeometries } from "../utils/geometries-intersection";
import { NavtexLayer } from "./navtex-layer";

export class NavtexLayerInForce extends NavtexLayer {
    constructor() {
        super();
        VesselPlanningModel!.addEventListener("executing-plan-changed", () => this.plot());
        VesselPlanningModel!.addEventListener(SuggestedRouteEvents.PlanChanged, () => this.plot());
        UiStateModel!.addEventListener(`${UiStateModelParam.ApplicationMode}-change`, () => this.plot());
    }
    
    async getStations() {
        let plan: VoyagePlan | null = null;
        
        const mode: FloatPanelComponent = <FloatPanelComponent>UiStateModel!.getValue(UiStateModelParam.ApplicationMode);

        if (mode === "suggestedRoutes" || mode === "routeEditor") {
            const activePlan = VoyageRoutingModel!.activePlan;
            if (activePlan) {
                plan = await VesselPlanningModel!.getCurrentPlan(activePlan);
            }
        } else {
            plan = await VesselPlanningModel!.getExecutingPlan();
        }
        
        if (plan) {
            const allStations = await VesselRs1345Model!.getStations();
            if (allStations.length === 0) {
                return [];
            }

            const currentSelectedRouteIndex = plan?.routes.findIndex(route => route.routeId === plan!.currentSelectedRouteId) ?? plan?.selectedRouteIndex;
            if(currentSelectedRouteIndex === -1) {
                return [];
            }
            const route = plan.routes[currentSelectedRouteIndex].route_geometry;
            const crossedStations = CrossedGeometries(route, allStations)

            return crossedStations;
        }

        return [];
    }
}
